'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('FluxoApropriacaoAplicacaoCtrl', function(aplicacao, $rootScope,
  MessagesService, $uibModalInstance, AuditoriaAplicacaoService, AplicacoesService) {
  const vm = this;

  vm.close = function() {
    $uibModalInstance.dismiss('cancel');
  };

  vm.remove = function() {
    MessagesService.confirm('Deseja excluir a auditoria?').then(function() {
      vm.loading = true;
      AuditoriaAplicacaoService.reject(aplicacao).then(function() {
        $rootScope.$broadcast('eventReloadNotifications');
        vm.close();
      })
        .catch(function(error) {
          MessagesService.alert('Ocorreu um erro, tente novamente.');
          console.error('Falha ao rejeitar aplicação', error);
        })
        .finally(function() {
          vm.loading = false;
        });
    });
  };

  // eslint-disable-next-line max-lines-per-function
  vm.loadAplicacoes = function() {
    const objeto = aplicacao.auditoria_aplicacao;
    const avulso = !(objeto.atributo_attributes || {}).recomendacao_id;
    vm.isTratamentoSemente = aplicacao.tipo_operacao_enum === 'operacao_tratamento_semente';
    vm.loadingAplicacoes = true;

    if (vm.isTratamentoSemente) {
      vm.loadAplicacoes = false;
      vm.errorLoadAplicacoes = 'Não é possível vincular tratamento de semente.';
      return;
    }

    if (avulso) {
      vm.loadAplicacoes = false;
      vm.errorLoadAplicacoes = 'Não é possível vincular pois este fluxo representa uma aplicação avulsa.';
      return;
    }

    AplicacoesService.listComplete({
      dataInicial: objeto.dt_ini,
      dataFinal: objeto.dt_fim,
      gleba: { id: objeto.cd_gleba },
      operacao: objeto.cd_operacao,
      cultura: { id: objeto.atividade }
    }).then(function(result) {
      vm.aplicacoes = result.data.filter(function(resultAplicacao) {
        // Somente quando não tem recomendação vinculada
        return !Object.values(resultAplicacao.recomendacao_datas || {}).length;
      });
      if (vm.aplicacoes.length) {
        vm.aplicacaoAssociada = vm.aplicacoes[0];
      }
      vm.loadingAplicacoes = false;
    })
      .catch(function(error) {
        console.error('Falha ao listar aplicações', error);
        vm.loadingAplicacoes = false;
      });
  };

  vm.initAssociar = function() {
    vm.associar = true;
  };

  vm.aprove = function() {
    vm.loading = true;
    AuditoriaAplicacaoService.aprove(aplicacao, vm.aplicacaoAssociada.id).then(function() {
      $rootScope.$broadcast('eventReloadNotifications');
      vm.close();
    })
      .catch(function(error) {
        MessagesService.alert('Ocorreu um erro, tente novamente.');
        console.error('Falha ao associar aplicação', error);
      })
      .finally(function() {
        vm.loading = false;
      });
  };

  vm.descriptionAplicacao = function(aplication) {
    const itens = aplication.itens.map(function(item) {
      return item.descricao;
    });
    return `Aplicação #${ aplication.id }. Produtos: ${ itens.join(',')}`;
  };

  vm.aplicacao = aplicacao;
  vm.associar = false;
  vm.loadingAplicacoes = false;
  vm.loading = false;
  vm.errorLoadAplicacoes = null;
  vm.loadAplicacoes();
});
